
export const readStoredCart = (storage, fallback) => {
  try {
    const stored = JSON.parse(storage.getItem("chawkbazar-cart") || "");
    // ponytail: react-use double-encoded old carts; remove after the migration window.
    const cart = typeof stored === "string" ? JSON.parse(stored) : stored;
    return Array.isArray(cart?.items) ? { ...fallback, ...cart } : fallback;
  } catch {
    return fallback;
  }
};

  export function addItemWithQuantity(
    items,
    item,
    quantity
  ) {
    if (quantity <= 0)
      throw new Error("cartQuantity can't be zero or less than zero");
    const existingItemIndex = items.findIndex(
      (existingItem) => existingItem.id === item.id
    );
  
    if (existingItemIndex > -1) {
      const newItems = [...items];
      newItems[existingItemIndex].quantity += quantity;
      if (item.coupon_id) {
        newItems[existingItemIndex].coupon_id = item.coupon_id;
        newItems[existingItemIndex].coupon_metadata = item.coupon_metadata || null;
      }
      return newItems;
    }
    return [...items, { ...item, quantity }];
  }
  
  export function removeItemOrQuantity(
    items,
    id,
    quantity
  ) {
    return items.reduce((acc, item) => {
      if (item.id === id) {
        const newQuantity = item.quantity - quantity;
  
        return newQuantity > 0
          ? [...acc, { ...item, quantity: newQuantity }]
          : [...acc];
      }
      return [...acc, item];
    }, []);
  }
  // Simple CRUD for Item
  export function addItem(items, item) {
    return [...items, item];
  }
  
  export function getItem(items, id) {
    return items.find((item) => item.id === id);
  }
  
  export function updateItem(
    items,
    id,
    item
  ) {
    return items.map((existingItem) =>
      existingItem.id === id ? { ...existingItem, ...item } : existingItem
    );
  }
  
  export function removeItem(items, id) {
    return items.filter((existingItem) => existingItem.id !== id);
  }
  
export const calculateItemTotals = (items) =>
  items.map((item) => ({
    ...item,
    itemTotal: getDiscountedUnitPrice(item) * item.quantity,
  }));
  
export const calculateTotal = (items) =>
    items.reduce((total, item) => total + item.quantity * getDiscountedUnitPrice(item), 0);

export const calculateFreeShippingTotal = (items) =>
  items.reduce((total, item) => {
    if (item.counts_for_free_shipping === false || item.counts_for_free_shipping === 0) {
      return total;
    }

    return total + item.quantity * getDiscountedUnitPrice(item);
  }, 0);
  
  export const calculateTotalItems = (items) =>
    items.reduce((sum, item) => sum + item.quantity, 0);
  
  export const calculateUniqueItems = (items) => items.length;
  
const getUnitCouponDiscount = (item) => {
  const coupon = item?.coupon_metadata;
  if (!coupon) return 0;
  if (coupon.scope === "shipping") return 0;

  const value = Number(coupon?.value);
  if (!Number.isFinite(value) || value <= 0) return 0;

  const type = String(coupon?.type || "").toLowerCase();
  if (type === "percent" || type === "percentage") {
    return item.price * (value / 100);
  }

  return value;
};

const getDiscountedUnitPrice = (item) => {
  const discount = getUnitCouponDiscount(item);
  return Math.max(Number(item.price) - discount, 0);
};
